<template>
  <v-container>
        <v-card hover ripple>
           <v-toolbar
           extended
             color="blue"
      dark
    >
      <v-icon>search</v-icon>
      <v-toolbar-title>Real Time Chat App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        
      </v-btn>
    </v-toolbar >
      <v-card-media
        src="https://images.unsplash.com/photo-1439886183900-e79ec0057170?dpr=1&auto=compress,format&fit=crop&w=991&h=608&q=80&cs=tinysrgb&crop="
        height="400px">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
    
  
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate
        dolorem doloribus esse expedita ipsum magnam necessitatibus neque, optio perferendis placeat
        porro quas quisquam repellat repellendus reprehenderit ut.
      </v-card-text>
     
      
        <v-spacer></v-spacer>
        <v-icon class="white--text">explore</v-icon>
         </v-card>
    <br>
    
   
   <v-card hover ripple>
           <v-toolbar
           extended
             color="pink"
      dark
    >
      <v-icon>search</v-icon>
      <v-toolbar-title>Real Time Chat App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        
      </v-btn>
    </v-toolbar >
      <v-card-media
        src="https://images.unsplash.com/photo-1439886183900-e79ec0057170?dpr=1&auto=compress,format&fit=crop&w=991&h=608&q=80&cs=tinysrgb&crop="
        height="400px">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
    
  
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate
        dolorem doloribus esse expedita ipsum magnam necessitatibus neque, optio perferendis placeat
        porro quas quisquam repellat repellendus reprehenderit ut.
      </v-card-text>
     
      
        <v-spacer></v-spacer>
        <v-icon class="white--text">explore</v-icon>
         </v-card>
    <br>
    
      <v-card hover ripple>
           <v-toolbar
           extended
             color="pink"
      dark
    >
      <v-icon>search</v-icon>
      <v-toolbar-title>Real Time Chat App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        
      </v-btn>
    </v-toolbar >
      <v-card-media
        src="https://images.unsplash.com/photo-1439886183900-e79ec0057170?dpr=1&auto=compress,format&fit=crop&w=991&h=608&q=80&cs=tinysrgb&crop="
        height="400px">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
    
  
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate
        dolorem doloribus esse expedita ipsum magnam necessitatibus neque, optio perferendis placeat
        porro quas quisquam repellat repellendus reprehenderit ut.
      </v-card-text>
     
      
        <v-spacer></v-spacer>
        <v-icon class="white--text">explore</v-icon>
         </v-card>
    <br>
    
      <v-card hover ripple>
           <v-toolbar
           extended
             color="pink"
      dark
    >
      <v-icon>search</v-icon>
      <v-toolbar-title>Real Time Chat App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        
      </v-btn>
    </v-toolbar >
      <v-card-media
        src="https://images.unsplash.com/photo-1439886183900-e79ec0057170?dpr=1&auto=compress,format&fit=crop&w=991&h=608&q=80&cs=tinysrgb&crop="
        height="400px">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
    
  
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate
        dolorem doloribus esse expedita ipsum magnam necessitatibus neque, optio perferendis placeat
        porro quas quisquam repellat repellendus reprehenderit ut.
      </v-card-text>
     
      
        <v-spacer></v-spacer>
        <v-icon class="white--text">explore</v-icon>
         </v-card>
    <br>
    
   


  </v-container>





     






</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
  },
};
</script>
